import LocomotiveScroll from "locomotive-scroll";
import { tns } from "tiny-slider/src/tiny-slider";
import Splitting from "splitting";
import { gsap } from "gsap";
import Swiper from "swiper/bundle";

window.LocomotiveScroll = LocomotiveScroll;
window.tns = tns;
window.Splitting = Splitting;
window.gsap = gsap;
window.Swiper = Swiper;
